import api from './api';

const authService = {
  // Login user
  login: async (email, password) => {
    const response = await api.post('/api/v1/auth/login', { email, password });
    return response.data.data; // ApiResponse wrapper
  },

  // Register new user
  register: async (userData) => {
    const response = await api.post('/api/v1/auth/simple-register', userData);
    return response.data.data; // ApiResponse wrapper
  },

  // Logout user
  logout: async () => {
    const response = await api.post('/api/v1/auth/logout');
    return response.data.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('/api/v1/auth/me');
    return response.data.data; // ApiResponse wrapper
  },

  // Refresh token
  refreshToken: async () => {
    const response = await api.post('/api/v1/auth/refresh');
    return response.data;
  },

  // Update user profile
  updateProfile: async (userData) => {
    const response = await api.put('/api/v1/auth/profile', userData);
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.put('/api/v1/auth/password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  // Request password reset
  requestPasswordReset: async (email) => {
    const response = await api.post('/api/v1/auth/forgot-password', { email });
    return response.data;
  },

  // Reset password with token
  resetPassword: async (token, newPassword) => {
    const response = await api.post('/api/v1/auth/reset-password', {
      token,
      newPassword,
    });
    return response.data;
  },
};

export default authService;
